import { hiddenContentStyle } from '../../Styling';
export var getStyles = function (props) {
    return {
        root: props.className,
        screenReaderText: hiddenContentStyle,
    };
};
//# sourceMappingURL=Announced.styles.js.map